var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',[_c('SiteMasthead',{attrs:{"title":"Properties For Rent","mini":"true"}}),_c('ContentRow',[_c('ContentContainer',[_c('ListingSearch',{attrs:{"method-of-sale":"rent"},on:{"filter_updated":_vm.handleFilter}}),(_vm.listingFilter)?_c('Listings',{attrs:{"filter":_vm.listingFilter}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }